export const fileAccessLogConstants = {
  GET_FILE_ACCESS_LOG_REQUEST: "GET_FILE_ACCESS_LOG_REQUEST",
  GET_FILE_ACCESS_LOG_SUCCESS: "GET_FILE_ACCESS_LOG_SUCCESS",
  GET_FILE_ACCESS_LOG_FAILURE: "GET_FILE_ACCESS_LOG_FAILURE",
  CLEAR_FILE_ACCESS_LOG: "CLEAR_FILE_ACCESS_LOG",
};
